// extracted by mini-css-extract-plugin
export default {"subtitle":"MultiplFileUpload_subtitle__gn5y-","subTitle":"MultiplFileUpload_subTitle__VkuER","title":"MultiplFileUpload_title__Tgm3I"};